<div class="wrap">

    <video #vid autoplay muted playsinline style="width:100%;max-width:960px; background:#000;"></video>
    <div class="actions">
        <button [disabled]="!selectedRecording" mat-flat-button color="primary" (click)="start()">Start</button>

    </div>

</div>